import React from "react";
import { ShieldCheck, Lightbulb, Handshake } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const values = [{
  title: "Musculoskeletal Pain",
  description: "Effective relief for chronic back pain, joint stiffness, and sports injuries through specialized therapeutic protocols designed to restore natural movement.",
  icon: ShieldCheck
}, {
  title: "Stress & Anxiety",
  description: "Comprehensive support for mental well-being, helping to regulate the nervous system and manage the physical manifestations of chronic stress.",
  icon: Lightbulb
}, {
  title: "Holistic Wellness",
  description: "Targeted approaches to improve gut health and metabolic function, addressing the root causes of internal discomfort for lasting vitality.",
  icon: Handshake
}];
export default function OurValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="36968" id="what-conditions-does-it-help" className="bg-background py-[120px] relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          {values.map((item, i) => <Card key={i} data-index={i} className="group bg-card border border-border rounded-[32px] transition-all duration-300 hover:bg-accent/5 hover:shadow-xl">
              <CardHeader className="pb-4">
                <div className="mb-6 inline-flex items-center justify-center">
                  <item.icon className="text-accent w-12 h-12 transition-transform duration-300 group-hover:scale-105" strokeWidth={1.25} />
                </div>
                <CardTitle className="text-foreground text-[24px] font-serif font-semibold tracking-tight">
                  {item.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-muted-foreground text-lg font-sans leading-relaxed">
                  {item.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}